import { Button, Modal } from '../ui';

type CompetencyQuickPickerProps = {
  isOpen: boolean;
  onClose: () => void;
  competencies: Array<{ id: number; name: string }>;
  onPick: (competencyId: number) => void;
};

export default function CompetencyQuickPicker({ isOpen, onClose, competencies, onPick }: CompetencyQuickPickerProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Kompetenz erfassen" size="md">
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {competencies.map((entry) => (
          <Button
            key={entry.id}
            variant="outline"
            size="md"
            className="justify-start py-3"
            onClick={() => {
              onPick(entry.id);
              onClose();
            }}
          >
            {entry.name}
          </Button>
        ))}
      </div>
    </Modal>
  );
}
